import React, { Component, createRef } from 'react';
import {
  View,
  Text,
  Image,
  TouchableOpacity,
  FlatList,
  ScrollView,
  BackHandler,
  NativeModules,
} from 'react-native';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FastImageView from '../../components/FastImageView';
import colors from '../../theme/Colors';
import images from '../../theme/Images';
import Utility from '../../utils/Utility';
import { getRoutineDetails, routineActivityDone } from '../../actions/RoutineActions';
import { uploadImageReview } from '../../actions/FacialAnalysisActions';
import ShimmerPlaceHolder from '../../libraries/ReactNativeShimmerPlaceholder';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { AnalyticsManager, EventParameterKey, EventType } from '../../analytics';
import RemoteConfig from '../../utils/RemoteConfig';
import { REMOTE_CONFIG_KEYS, ROUTINE_ACTIVITY_TYPES } from '../../config/Constants';
import CameraUtils from '../../utils/CameraUtils';
import Toast from 'react-native-easy-toast';
import ErrorBoundary from '../../components/shared/ErrorBoundary';
import { isDesktop, isNative, isWeb, isIOS, isAndroid, isPresent, isBlank } from '../../utils/BooleanUtility';
import { getFirebasePerformanceTrace } from '../../utils/PerfUtility';
import PermissionsUtility from '../../utils/PermissionsUtility';
import { foxyImagePicker } from '../../utils/ImagePickerUtility';
import withProfiledNavigation from '../../utils/withProfiledNavigation';
import { ReactNavigationPerformanceView } from '@shopify/react-native-performance-navigation';
import { cancelNotificationsByActivityId, fetchRoutineNotificationsDetail, scheduleNotifications } from './RoutineNotificationUtility';
import { getScreenWidth } from '../../utils/LayoutUtility';
import { fetchCometChatUser, fetchMessageConversation } from '../../utils/ApiCallingUtility';
import RoutinesUtility, { getFormattedSlug } from '../../components/Routines/RoutinesUtility';
import { navigationRef } from '../../navigator/NavigationService';
import { ids, styles } from './Styles';

var JSONAPIDeserializer = require('jsonapi-serializer').Deserializer;

const withRoutineDetails = (WrappedComponent, screenConstant) => {
  class RoutineDetailsHOC extends Component {
    constructor(props) {
      super(props);
      const { navigation, route } = props;
      this.slug = getFormattedSlug(route?.params) || '';
      this.currentState = route.params?.extra?.current_state;
      this.state = {
        selectedDay: screenConstant === SCREEN_CONSTANTS.DURING_ROUTINE ? 1 : 0,
        selectedDayDateTime: new Date(),
        itemData: {},
        currentRoutineDayData: {}, // Changed from array to object
        dailyPhotoes: [],
        isLoading: true,
        serverError: false,
        retryLoading: false,
        connectionError: false,
        myDailyRanks: [],
        selectedDayActivitiesData: [],
        layouts: {},
        liveStreams: [],
        skinHappinessScore: [],
        routineDaysData: [],
        isSelectedDayLoading: false,
      };

      this.trace = getFirebasePerformanceTrace(screenConstant);
      this.trace.start();

      this.requireUserAttributes = route?.params?.requiredUserAttributes;
      this.personalizedSlug = route.params?.personalizedSlug || '';
      this.fetchRoutineDetails();

      this.shimmerColors = ['#fafafa', '#eeeeee', '#fafafa'];
      if (Utility.isAndroid()) {
        this.backhandler = BackHandler.addEventListener('hardwareBackPress', this.onBackPress);
      }
      this.routineId = '';
      this.activityId = '';
      this.successCallback = () => {};
      this.notificationActivityId = route?.params?.notificationActivityId;
      this.fileInputRef = createRef();
      this.uploadImageData = {};
      this.enableCachingForRoutines = RemoteConfig.getValue(
        REMOTE_CONFIG_KEYS.enable_caching_for_routines,
      ) || true;
    }

    componentDidMount() {
      AnalyticsManager.setCurrentScreen(screenConstant);
      this.rateExperienceDetails = RemoteConfig.getValue(REMOTE_CONFIG_KEYS.routine_rate_experience);
      const { navigation } = this.props;
      this.unsubscribe = navigation.addListener('focus', () => Utility.setStatusbarTranslucent());
      this.unsubscribeBlur = navigation.addListener('blur', () => {
        const { presentation } = navigationRef.getCurrentOptions() || {};
        if (presentation !== 'transparentModal') Utility.setStatusBarWhite();
      });
      if (isNative()) {
        fetchCometChatUser(false, () => {});
      }
    }

    componentDidUpdate(prevProps, prevState) {
      const { selectedDayActivitiesData, layouts } = this.state;
      if (
        isBlank(this.scrollViewY) &&
        isPresent(selectedDayActivitiesData) &&
        isPresent(layouts) &&
        selectedDayActivitiesData.length === Object.values(layouts).length
      ) {
        const activityIndex = this.findNotificationActivityIndex();
        if (this.activityListRef) {
          this.scrollViewY = layouts[activityIndex]?.y || 0;
          this.activityListRef.scrollTo({ x: 0, y: this.scrollViewY, animated: true });
        }
      }
      this.storagePermissionStatus = PermissionsUtility.checkPreviousStoragePermission(prevProps);
    }

    componentWillUnmount() {
      this.unsubscribe();
      this.unsubscribeBlur();
      Utility.setStatusBarWhite();
      if (Utility.isAndroid()) this.backhandler?.remove();
      if (!this.traceStopped) {
        this.trace.stop();
        this.traceStopped = true;
      }
    }

    fetchRoutineDetails = async () => {
      const { getRoutineDetails } = this.props;
      try {
        const response = await new Promise((resolve, reject) => {
          getRoutineDetails(this.slug, (success, res) => (success ? resolve(res) : reject(res)), false, false, false);
        });
        const data = await new JSONAPIDeserializer({
          typeAsAttribute: false,
          pluralizeType: true,
          keyForAttribute: 'camelCase',
        }).deserialize(response);

        this.trace.stop();
        this.traceStopped = true;

        const {
          currentRoutineDay = {},
          userSkinHappinessScores = [],
          currentDay = 1,
          routineDays = [],
          currentRoutineDay: { routineActivities = [], summaryCard = {} } = {},
        } = data;
        const initialSelectedDay = screenConstant === SCREEN_CONSTANTS.DURING_ROUTINE ? currentRoutineDay?.dayNum : 0;
        const postRoutineDaysData = {
          dayNum: 0,
        };
        const updatedRoutineDays =
          screenConstant === SCREEN_CONSTANTS.DURING_ROUTINE ? routineDays : [postRoutineDaysData, ...routineDays];

        this.setState(
          {
            currentRoutineDayData: currentRoutineDay,
            selectedDay: initialSelectedDay,
            liveStreams: this.parseDailyLiveStreamVideos(currentRoutineDay),
            dailyPhotoes: this.parseDailyPhotoes(currentRoutineDay),
            isLoading: false,
            retryLoading: false,
            itemData: data,
            connectionError: false,
            myDailyRanks: this.calculateDailyRanks(currentRoutineDay),
            skinHappinessScore: userSkinHappinessScores,
            routineDaysData: updatedRoutineDays,
            selectedDayActivitiesData: routineActivities,
            selectedDaySummaryCardContent: summaryCard,
          },
          () => this.setScrollIndex(initialSelectedDay),
        );

        AnalyticsManager.logEvent(EventType.pageLoad.PAGE_LOAD, { [EventParameterKey.PAGE]: screenConstant });
        this.fireRoutineViewEvent(initialSelectedDay);
        if (isNative() && screenConstant === SCREEN_CONSTANTS.DURING_ROUTINE) {
          fetchRoutineNotificationsDetail(this.slug);
        }
      } catch (error) {
        this.setState({
          isLoading: false,
          retryLoading: false,
          connectionError: error.status === 'connection_error',
          serverError: error.status === 'server_error',
        });
      }
    };

    parseDailyLiveStreamVideos = (currentRoutineDay) => {
      const liveStream = currentRoutineDay?.routineActivities?.find(
        (activity) => activity.activity?.arguments?.cardType === 'liveStream',
      );
      return [liveStream || null]; // Return as array with single item
    };

    calculateDailyRanks = (currentRoutineDay) => {
      if (currentRoutineDay?.myRank && currentRoutineDay?.dayNum && currentRoutineDay.myRank < 4) {
        return [{ myRank: currentRoutineDay.myRank, day: currentRoutineDay.dayNum }];
      }
      return [];
    };

    parseDailyPhotoes = (currentRoutineDay) => {
      if (currentRoutineDay?.myPhoto) {
        return [{ image: currentRoutineDay.myPhoto, day: currentRoutineDay.dayNum }];
      }
      return [];
    };

    updateMarkAsDoneInState = (id) => {
      this.setState((prevState) => {
        const { currentRoutineDayData, selectedDay } = prevState;
        const updatedActivities = currentRoutineDayData?.routineActivities?.map((activity) =>
          activity?.id === id ? { ...activity, markedDone: true } : activity,
        );

        return {
          currentRoutineDayData: {
            ...currentRoutineDayData,
            routineActivities: updatedActivities,
          },
        };
      });
    };

    fireRoutineViewEvent = (day = '') => {
      const { itemData: { id = '', name = '' } = {} } = this.state;
      const viewMeta = {
        [EventParameterKey.ROUTINES.PAGE_TYPE]: screenConstant,
        [EventParameterKey.ROUTINES.ROUTINE_NAME]: name,
        [EventParameterKey.ROUTINES.ROUTINE_ID]: id,
        ...(day && { [EventParameterKey.ROUTINES.ROUTINE_DAY]: day }),
      };
      AnalyticsManager.logEvent(EventType.routine.ROUTINE_VIEW, viewMeta);
    };

    onBackPress = () => {
      const { navigation } = this.props;
      const { routes = [] } = navigation.getState();
      if (isBlank(routes) || routes.length < 2) {
        navigation.replace('TabNavigator');
        return true;
      }
      navigation.goBack();
      return true;
    };

    onShareTapped = () => {
      const { itemData: { name = '', id = '', skuId = '', shareUrl = '' } = {} } = this.state;
      const generalShareOption = {
        title: 'Foxy',
        message: `Check out this amazing routine I am participating in: ${name}. Let's join it together & help each other achieve our goals ✨`,
        url: shareUrl,
      };
      Utility.onShareTapped(shareUrl, generalShareOption);
      AnalyticsManager.logEvent(EventType.routine.ITEM_CLICK, {
        [EventParameterKey.ACTION]: 'share',
        [EventParameterKey.NAME]: name,
        [EventParameterKey.ID]: id,
        [EventParameterKey.SCREEN_NAME]: screenConstant,
        [EventParameterKey.SKU_ID]: skuId,
      });
    };

    navigateToDetailsPage = () => {
      const { navigation } = this.props;
      const { itemData, itemData: { id = '', name = '', skuId = '' } = {} } = this.state;
      AnalyticsManager.logEvent(EventType.routine.ITEM_CLICK, {
        [EventParameterKey.ACTION]: 'info',
        [EventParameterKey.NAME]: name,
        [EventParameterKey.ID]: id,
        [EventParameterKey.SCREEN_NAME]: screenConstant,
        [EventParameterKey.SKU_ID]: skuId,
      });
      navigation.push('PreRoutineDetails', { slug: this.slug, source: screenConstant, itemData });
    };

    onChatTapped = () => {
      const { itemData: { cometChatGroup: { id = '' } = {} } = {} } = this.state;
      fetchMessageConversation(id, this.navigateToMessageInbox);
    };

    navigateToMessageInbox = (item) => {
      const { name = '', skuId = '', id: routineId = '', status = '', cometChatGroupsSchedules = [] } = item;
      AnalyticsManager.logEvent(EventType.routine.ITEM_CLICK, {
        [EventParameterKey.ACTION]: 'chat',
        [EventParameterKey.NAME]: name,
        [EventParameterKey.ID]: routineId,
        [EventParameterKey.SCREEN_NAME]: screenConstant,
        [EventParameterKey.SKU_ID]: skuId,
      });
      const { navigation } = this.props;
      navigation.navigate('Messages', {
        item,
        isArchived: status === 'archived',
        cometChatGroupsSchedules,
        isUpcoming: status === 'upcoming',
      });
    };

    header = () => {
      const { itemData: { name = '', cometChatGroup = {} } = {}, isLoading = false } = this.state;
      const headerStyle = isWeb() ? styles.headerContainerWeb : styles.headerContainer;
      return (
        <View style={headerStyle}>
          <TouchableOpacity style={styles.headerIconContainer} onPress={this.onBackPress}>
            <Image source={images.ic_back_product} style={styles.headerIcon} />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>{name}</Text>
          {!isLoading && isPresent(cometChatGroup) && (
            <TouchableOpacity style={styles.headerIconContainer} onPress={this.onChatTapped}>
              <FastImageView
                source={images.routines.whatsApp_white}
                style={styles.headerIcon}
                tintColor={colors.black}
                resizeMode='contain'
              />
            </TouchableOpacity>
          )}
          {isNative() && !isLoading && (
            <TouchableOpacity style={styles.headerIconContainer} onPress={this.onShareTapped}>
              <FastImageView source={images.routines.share_icon} style={styles.headerIcon} />
            </TouchableOpacity>
          )}
          {!isLoading && (
            <TouchableOpacity style={styles.headerIconContainer} onPress={this.navigateToDetailsPage}>
              <FastImageView source={images.routines.info_icon} style={styles.headerIcon} />
            </TouchableOpacity>
          )}
        </View>
      );
    };

    emptyHeader = () => (
      <View style={isWeb() ? styles.headerContainerWeb : styles.headerContainer}>
        <TouchableOpacity style={styles.headerIconContainer} onPress={this.onBackPress}>
          <Image source={images.ic_back_product} style={styles.headerIcon} />
        </TouchableOpacity>
      </View>
    );

    screenPlaceholder = () => (
      <ScrollView showsVerticalScrollIndicator={false}>
        <ShimmerPlaceHolder colorShimmer={this.shimmerColors} autoRun style={styles.placeholderTitle} />
        <FlatList
          data={new Array(5)}
          horizontal
          keyExtractor={(item) => `${item}`}
          renderItem={() => (
            <ShimmerPlaceHolder colorShimmer={this.shimmerColors} autoRun style={styles.placeholderListItem} />
          )}
          showsHorizontalScrollIndicator={false}
          bounces={false}
        />
      </ScrollView>
    );

    markRoutineActivityAsDone = (id, activityType, successCallback = () => {}) => {
      const { itemData: { slug = '' } = {}, currentRoutineDayData } = this.state;
      const { routineActivityDone } = this.props;
      routineActivityDone(slug, id, (success, response) => {
        if (success) {
          this.setState((prevState) => ({
            itemData: {
              ...prevState.itemData,
              myRewardPoints: response?.points || prevState.itemData.myRewardPoints,
            },
          }));
          this.cancelScheduledNotification(response?.cancel_notifications_for);
          if (activityType === ROUTINE_ACTIVITY_TYPES.UPLOAD && Utility.isBlank(response.image_urls)) {
            if (isWeb()) {
              this.uploadImageData = { id, activity_id: response?.id, success_callback: successCallback };
              this.handleFilePicker();
            } else {
              this.openGallery(id, successCallback, response?.id);
            }
            return;
          }
          this.updateMarkAsDoneInState(id);
          successCallback(true);
        }
      });
    };

    cancelScheduledNotification = (activityIds = []) => {
      if (!Array.isArray(activityIds) || activityIds.length === 0) return;
      if (isAndroid()) {
        activityIds.forEach((activityId) => activityId && cancelNotificationsByActivityId(activityId));
      } else if (isIOS()) {
        NativeModules.LocalNotificationHandler.cancelScheduledNotifications(activityIds);
      }
    };

    updateMarkAsDoneInState = (id) => {
      this.setState((prevState) => {
        const { currentRoutineDayData } = prevState;
        const updatedActivities = currentRoutineDayData.routineActivities.map((activity) =>
          activity.id === id ? { ...activity, markedDone: true } : activity
        );
        return {
          currentRoutineDayData: {
            ...currentRoutineDayData,
            routineActivities: updatedActivities,
          },
        };
      });
    };

    openGallery = async (id, successCallback, activity_id) => {
      const { appendedImages: mediaData } = await foxyImagePicker({
        allowMediaSingleSelection: true,
        imagePickerProps: { mediaType: 'photo', multiple: false },
        onCancelAlert: this.onCancelAlert,
        storagePermissionStatus: this.storagePermissionStatus,
        successCallback,
        id,
        activity_id,
      });
      if (isPresent(mediaData)) this.convertImageToBase64AndUpload(id, mediaData?.path, successCallback, activity_id);
    };

    onCancelAlert = () => {
      const { navigation } = this.props;
      this.successCallback(false);
      navigation.goBack();
    };

    convertImageToBase64AndUpload = (id, uri, successCallback, activity_id) => {
      CameraUtils.convertImageToBase64(uri)
        .then((response) => {
          const postData = {
            base64Data: `data:image/jpeg;base64,${response}`,
            id: activity_id,
            type: 'UsersRoutineActivity',
          };
          this.uploadImageReview(postData, id, successCallback);
        })
        .catch(() => successCallback(false));
    };

    uploadImageReview = (postData, id, successCallback) => {
      const { uploadImageReview } = this.props;
      uploadImageReview(postData, (success) => {
        if (success) {
          this.markRoutineActivityAsDone(id, ROUTINE_ACTIVITY_TYPES.UPLOAD, successCallback);
          successCallback(true);
        } else {
          successCallback(false);
          this.toast?.show('Error Uploading! Please try again.', 1000);
        }
      });
    };

    handleFilePicker = () => this.fileInputRef.current?.click();

    handleFileChange = async (event) => {
      const files = Array.from(event.target.files);
      const imageData = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.readAsDataURL(files[0]);
      });
      const postData = { base64Data: imageData, id: this.uploadImageData.activity_id, type: 'UsersRoutineActivity' };
      this.uploadImageReview(postData, this.uploadImageData.id, this.uploadImageData.success_callback);
    };

    onChangeDay = (day, selectedDayData = {}) => {
      const { id = '', dayNum } = selectedDayData;

      this.setScrollIndex(dayNum);
      this.handleDaySelection(dayNum, id);

      if (screenConstant === SCREEN_CONSTANTS.DURING_ROUTINE) {
        this.fireRoutineViewEvent(day);
      }
    };

    handleDaySelection = (dayNum, id) => {
      const {
        itemData: { currentRoutineDay = {} },
      } = this.state;
      const isCurrentDaySelected = dayNum === currentRoutineDay?.dayNum;
      if (isCurrentDaySelected) {
        this.updateCurrentDay(currentRoutineDay, dayNum);
      } else {
        this.loadNewDay(dayNum, id);
      }
    };

    updateCurrentDay = (currentRoutineDay, dayNum) => {
      this.setState({ isSelectedDayLoading: true }, () => this.updateSelectedDayState(currentRoutineDay, dayNum));
    };

    loadNewDay = (dayNum, id) => {
      this.setState(
        {
          selectedDay: dayNum,
          isSelectedDayLoading: true,
          selectedDaySummaryCardContent: {},
        },
        () => {
          if (isPresent(id)) {
            this.fetchSelectedDayData(id, dayNum);
          }
        },
      );
    };

    fetchSelectedDayData = async (id, day) => {
      const { getRoutineDetails } = this.props;
      const slug = `${this.slug}/routine_days/${id}`;
      try {
        const response = await new Promise((resolve, reject) => {
          getRoutineDetails(slug, (success, res) => (success ? resolve(res) : reject(res)), false, false, true);
        });
        const data = await new JSONAPIDeserializer({
          typeAsAttribute: false,
          pluralizeType: true,
          keyForAttribute: 'camelCase',
        }).deserialize(response);
        this.updateSelectedDayState(data, day);
      } catch (error) {
        this.setState({
          retryLoading: false,
          connectionError: error.status === 'connection_error',
          serverError: error.status === 'server_error',
          isSelectedDayLoading: false,
        });
      }
    };

    updateSelectedDayState = (data, day) => {
      this.setState({
        currentRoutineDayData: data,
        selectedDay: day,
        liveStreams: this.parseDailyLiveStreamVideos(data),
        dailyPhotoes: this.parseDailyPhotoes(data),
        myDailyRanks: this.calculateDailyRanks(data),
        selectedDayActivitiesData: data?.routineActivities,
        selectedDaySummaryCardContent: data?.summaryCard,
        isSelectedDayLoading: false,
      });
    };

    setScrollIndex = (index) => {
      if (this.flatlistRef && index > 5 && this.state.routineDaysData?.length > index) {
        this.flatlistRef.scrollToIndex({ animated: true, index: index - 4 });
      }
    };

    setListRef = (ref) => (this.flatlistRef = ref);
    setActivityListRef = (ref) => (this.activityListRef = ref);
    findNotificationActivityIndex = () => {
      const { selectedDayActivitiesData } = this.state;
      return selectedDayActivitiesData.findIndex((e) => e?.id === this.notificationActivityId);
    };

    onPressReload = () => this.setState({ retryLoading: true, isLoading: true }, this.fetchRoutineDetails);

    toastRef = (ref) => (this.toast = ref);
    showActivityToast = (message) => this.toast?.show(message, 3000);

    render() {
      const {
        serverError,
        retryLoading,
        connectionError,
        itemData,
        routineDaysData,
        selectedDayActivitiesData = [],
        isSelectedDayLoading = false,
        selectedDaySummaryCardContent = {},
        selectedDay = '',
      } = this.state;
      return (
        <ReactNavigationPerformanceView screenName={screenConstant.toLowerCase()} interactive={isPresent(itemData)}>
          {(serverError || connectionError) && <this.emptyHeader />}
          <ErrorBoundary
            showServerError={serverError}
            onPressReload={this.onPressReload}
            connectionError={connectionError}
            loading={retryLoading}
            hideHeader
            screen_name={`${screenConstant.toLowerCase()}_detail`}
          >
            <View style={styles.container}>
              {!isDesktop() && <this.header />}
              <WrappedComponent
                {...this.props}
                {...this.state}
                header={this.header}
                markRoutineActivityAsDone={this.markRoutineActivityAsDone}
                onChangeDay={this.onChangeDay}
                setListRef={this.setListRef}
                setActivityListRef={this.setActivityListRef}
                showActivityToast={this.showActivityToast}
                fileInputRef={this.fileInputRef}
                handleFileChange={this.handleFileChange}
                isRoutineActive={screenConstant === SCREEN_CONSTANTS.DURING_ROUTINE}
                routineDaysData={routineDaysData}
                selectedDayActivitiesData={selectedDayActivitiesData}
                isSelectedDayLoading={isSelectedDayLoading}
                selectedDaySummaryCardContent={selectedDaySummaryCardContent}
                selectedDay={selectedDay}
              />
            </View>
          </ErrorBoundary>
          <Toast ref={this.toastRef} style={styles.toastStyle} />
        </ReactNavigationPerformanceView>
      );
    }
  }

  const mapStateToProps = (state) => ({
    phone: state.UserAccountInfo.mobileNumber,
    permissionStatus: state.permissionStatus,
    lastNotificationModalDisplayTime: state.UserAccountInfo.lastNotificationModalDisplayTime,
    initial_app_opened_at: state.UserAccountInfo.initial_app_opened_at,
  });

  const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ getRoutineDetails, routineActivityDone, uploadImageReview }, dispatch),
  });

  return withProfiledNavigation(connect(mapStateToProps, mapDispatchToProps)(RoutineDetailsHOC));
};

export default withRoutineDetails;
